export default {
    type: 'numeric',
    format: {
        decimals: 3,
        min: 0,
        max: 10
    },
    default: {
        logic: 'min'
    },
    setting: {
        logic: ['match', 'min', 'max', 'range', 'tolerance']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Rating Disparity',
        category: ['User', 'Ratings'],
        description: 'Rating disparity against the community for the game.',
        summarise: {
            prefix: 'Rating disparity'
        }
    }
}